import * as React from 'react';
import ComingSoonView from '../coming-soon-view';

export default function SaiView() {
  return (<ComingSoonView heading="Student Aid Index: ETL Pipeline" />); 
}